import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { DPFormField } from 'src/app/core/models/DPFormField';

/**
 * Multi line text field.
 * 
 * The value is entered text string.
 */
@Component({
  selector: 'app-multi-line',
  standalone: true,
  imports: [NgClass, ReactiveFormsModule],
  templateUrl: './multi-line.component.html',
  styleUrls: ['./multi-line.component.scss'],
})
export class MultiLineComponent implements OnInit {
  @Input() field: DPFormField;
  @Input() control: UntypedFormControl;
  @Input() disabled: boolean;

  constructor() {}

  ngOnInit(): void {}
}
